import React from 'react';
import history from './router/history';
import Router from './router/Router';

import './App.scss';

export class App extends React.PureComponent {
  render() {
    return (
      <div className="App">
        <Router history={history} />
      </div>
    );
  }
}

export default App;
